import { Movie } from "../types";
import { MOVIE_KEY } from "./constants";
import { get, set } from "./get-set";

export const toggleSeen = ({ title, release: { date } }: Movie) => {
  const existingData = get() || { [MOVIE_KEY]: { seen: [] } };

  const movieStoredData = existingData[MOVIE_KEY]?.seen || [];
  if (movieStoredData.includes(`${title}/${date}`)) {
    existingData[MOVIE_KEY].seen = movieStoredData.filter(
      (e) => e !== `${title}/${date}`
    );
  } else {
    movieStoredData.push(`${title}/${date}`);
  }
  set(existingData);
  return existingData[MOVIE_KEY].seen;
};

export const getSeen = ({ title, release: { date } }: Movie) => {
  const existingData = get();
  console.log(existingData);
  return !!existingData[MOVIE_KEY]?.seen.includes(`${title}/${date}`);
};

export const getFavorited = ({ title, release: { date } }: Movie) => {
  const existingData = get();
  console.log(existingData);
  return !!existingData[MOVIE_KEY]?.favorited.includes(`${title}/${date}`);
};
export const getSeenList = () => {
  const existingData = get();
  console.log(existingData);
  return existingData[MOVIE_KEY]?.seen || [];
};

export const getFavoritedList = () => {
  const existingData = get();
  console.log(existingData);
  return existingData[MOVIE_KEY]?.favorited || [];
};

export const toggleFavorite = ({ title, release: { date } }: Movie) => {
  const existingData = get() || { [MOVIE_KEY]: { favorited: [] } };

  const movieStoredData = existingData[MOVIE_KEY]?.favorited || [];
  if (movieStoredData.includes(`${title}/${date}`)) {
    existingData[MOVIE_KEY].favorited = movieStoredData.filter(
      (e) => e !== `${title}/${date}`
    );
  } else {
    movieStoredData.push(`${title}/${date}`);
  }
  set(existingData);
  return existingData[MOVIE_KEY].favorited;
};
